<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group" v-if="groupedLocations">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <!-- <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div> -->
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Date și oră</label>
              <el-date-picker
                type="datetimerange"
                v-model="searchDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="w-100"
                :picker-options="pickerOptions"
                :disabled="loading || !selectedGestiune"
                placeholder="Selectează intervalul"
              ></el-date-picker>
            </div>
          </div>
         </div>
         <div class="right-buttons" style="display: flex; align-items: center; justify-content: flex-end;">
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="triggerFilter"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
          <div class="search-button-reports pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="fetchSalesMarkupReport('xls')">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div>
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="tableInvoice" style="overflow-x: auto;">
              <div v-if="tableData && tableData.length" class="consumption-total-header">
                <strong>TOTAL ADAOS:</strong>
                {{ totalItems }} produse —
                <strong>{{ totalValue.toFixed(2) }} lei</strong>
              </div>
              <el-table
                :data="tableData"
                @row-click="openViewSalesMarkup"
                :empty-text="$t('gestiune.noData')"
                style="min-width: max-content;"
              >

                <!-- PRODUS -->
                <el-table-column
                  prop="product_name"
                  :label="$t('gestiune.product')"
                  min-width="180"
                />

                <!-- CANTITATE -->
                <el-table-column
                  :label="$t('gestiune.cantitate')"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    {{ scope.row.quantity > 0 ? Number(scope.row.quantity).toFixed(2) : '-' }}
                  </template>
                </el-table-column>

                <!-- UM -->
                <el-table-column
                  label="UM"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    {{ scope.row.unit || '-' }}
                  </template>
                </el-table-column>

                <!-- PREȚ INTRARE -->
                <el-table-column
                  label="Preț intrare"
                  min-width="140"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.in_price > 0">
                      {{ Number(scope.row.in_price).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

                <!-- PREȚ VÂNZARE -->
                <el-table-column
                  label="Preț vânzare"
                  min-width="140"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.sale_price > 0">
                      {{ Number(scope.row.sale_price).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

                <!-- TVA % -->
                <el-table-column
                  label="TVA %"
                  min-width="80"
                >
                  <template slot-scope="scope">
                    {{ scope.row.vat_percent > 0 ? scope.row.vat_percent + '%' : '-' }}
                  </template>
                </el-table-column>

                <!-- TVA VALOARE -->
                <el-table-column
                  label="TVA valoare"
                  min-width="140"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.vat_value > 0">
                      {{ Number(scope.row.vat_value).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

                <!-- DISCOUNT -->
                <el-table-column
                  label="Discount"
                  min-width="140"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.discount_value > 0">
                      {{ Number(scope.row.discount_value).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

                <!-- DISCOUNT TVA -->
                <el-table-column
                  label="Discount TVA"
                  min-width="160"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.discount_vat_value > 0">
                      {{ Number(scope.row.discount_vat_value).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

                <!-- MARKUP / ADAOS -->
                <el-table-column
                  label="Adaos"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.markup_value > 0">
                      {{ Number(scope.row.markup_value).toFixed(2) }} lei
                    </span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>

              </el-table>
            </div>
           </div>
      </div>
      <vmodal ref="salesMarkupModal" name="salesMarkupModal" height="auto" width="1200" class="salesMarkupModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>Detalii produs: {{ selectedProduct.name }}</p>
            </div>
            <div class="modal-body">
              <el-table :data="selectedProduct.purchaseDocuments" style="width: 100%">

                <el-table-column label="Cantitate">
                  <template slot-scope="scope">
                    {{ Number(scope.row.quantity).toFixed(2) }}
                  </template>
                </el-table-column>

                <el-table-column prop="unit" label="UM"/>

                <el-table-column label="Preț intrare">
                  <template slot-scope="scope">
                    {{ Number(scope.row.in_price).toFixed(2) }} lei
                  </template>
                </el-table-column>

                <el-table-column label="Preț vânzare">
                  <template slot-scope="scope">
                    {{ Number(scope.row.sale_price).toFixed(2) }} lei
                  </template>
                </el-table-column>

                <el-table-column label="TVA %">
                  <template slot-scope="scope">
                    {{ scope.row.vat_percent }}%
                  </template>
                </el-table-column>

                <el-table-column label="TVA valoare">
                  <template slot-scope="scope">
                    {{ Number(scope.row.vat_value).toFixed(2) }} lei
                  </template>
                </el-table-column>

                <el-table-column label="Discount">
                  <template slot-scope="scope">
                    {{ Number(scope.row.discount_value).toFixed(2) }} lei
                  </template>
                </el-table-column>

                <el-table-column label="Discount TVA">
                  <template slot-scope="scope">
                    {{ Number(scope.row.discount_vat_value).toFixed(2) }} lei
                  </template>
                </el-table-column>

                <el-table-column label="Adaos">
                  <template slot-scope="scope">
                    {{ Number(scope.row.markup_value).toFixed(2) }} lei
                  </template>
                </el-table-column>

              </el-table>
            </div>
            <div class="modal-footer">
              <a @click="closesalesMarkupModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
            </div>
          </div>
        </div>
      </vmodal>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    const end = new Date()
    const start = new Date()
    start.setDate(end.getDate() - 29)
    start.setHours(0, 0, 0, 0)
    end.setHours(23, 59, 59, 999)

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      totalValue: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [
          {
            text: 'Astăzi',
            onClick (picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ieri',
            onClick (picker) {
              const start = new Date()
              start.setDate(start.getDate() - 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setDate(end.getDate() - 1)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 7 zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 30 de zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna curentă',
            onClick (picker) {
              const start = new Date()
              start.setDate(1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna trecută',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
              const end = new Date(date.getFullYear(), date.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul curent',
            onClick (picker) {
              const start = new Date(new Date().getFullYear(), 0, 1)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul trecut',
            onClick (picker) {
              const year = new Date().getFullYear() - 1
              const start = new Date(year, 0, 1)
              const end = new Date(year, 11, 31)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick ({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0)
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999)
          }
        }
      }
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    selectedLocation (newLocation) {
      this.resetTable()

      this.selectedGestiune = null
      this.tableData = []
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
    },
    openViewSalesMarkup (row) {
      this.selectedProduct = {
        name: row.product_name,

        // RAW LINES (NEAGREGATE)
        purchaseDocuments: row.purchaseDocuments || []
      }

      this.$refs.salesMarkupModal.open()
    },
    closesalesMarkupModal () {
      this.$modal.hide('salesMarkupModal')
    },
    triggerFilter () {
      if (!this.selectedGestiune) {
        return
      }
      if (!this.selectedLocation) {
        return
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return
      }

      this.resetTable()
      this.fetchSalesMarkupReport()
    },
    getCategoryClass (categorie) {
      if (!categorie) return ''

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa': return 'marfa'
        case 'semifabricate-(reteta)': return 'semifabricate'
        case 'materii-prime': return 'materii-prime'
        case 'produs-finit-(reteta)': return 'produs-finit'
        default: return ''
      }
    },
    async fetchSalesMarkupReport (exportFormat = null) {
      if (!this.searchDate) return

      this.loading = true

      swal({
        type: 'info',
        title: 'Se generează raportul de adaos',
        text: 'Vă rugăm așteptați...',
        allowOutsideClick: false,
        didOpen: () => swal.showLoading()
      })

      try {
        const externalCompanyId = this.$session.get('selectedCompany')
        const [startDate, endDate] = this.searchDate

        const params = new URLSearchParams({
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString()
        })

        // one required: location OR company
        params.append('externalCompanyId', externalCompanyId)

        if (this.selectedLocation && this.selectedLocation.true_id) {
          params.append('externalLocationId', this.selectedLocation.true_id)
        }

        let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/raport-vazari-adaos?${params.toString()}`

        if (exportFormat) {
          url += `&export=${exportFormat.toUpperCase()}`
        }

        const response = await fetch(url)
        console.log('Răspuns raport adaos vânzări:', response)

        if (!response.ok) throw new Error(`HTTP ${response.status}`)

        // 📥 EXPORT XLS
        if (exportFormat) {
          window.location.href = url

          setTimeout(() => {
            swal.close()
          }, 800)

          return
        }

        // JSON
        const data = await response.json()

        if (Array.isArray(data.items)) {
          const grouped = Object.values(
            data.items.reduce((acc, item) => {
              const key = item.productId || item.product_name // fallback dacă nu ai id

              if (!acc[key]) {
                acc[key] = {
                  productId: item.productId,
                  product_name: item.product_name,
                  unit: item.unit,
                  quantity: 0,
                  in_price: item.in_price,
                  sale_price: item.sale_price,
                  vat_percent: item.vat_percent,
                  vat_value: 0,
                  discount_value: 0,
                  discount_vat_value: 0,
                  markup_value: 0,
                  purchaseDocuments: []
                }
              }

              acc[key].quantity += Number(item.quantity) || 0
              acc[key].vat_value += Number(item.vat_value) || 0
              acc[key].discount_value += Number(item.discount_value) || 0
              acc[key].discount_vat_value += Number(item.discount_vat_value) || 0
              acc[key].markup_value += Number(item.markup_value) || 0

              acc[key].purchaseDocuments.push(item)

              return acc
            }, {})
          )

          this.totalValue = grouped.reduce((sum, item) => {
            return sum + (Number(item.markup_value) || 0)
          }, 0)

          this.tableData = grouped
        } else {
          this.tableData = []
        }

        this.totalItems = data.totalItems || 0
      } catch (err) {
        console.error('Eroare raport adaos vânzări:', err)
        this.tableData = []

        swal({
          title: 'Eroare',
          text: 'Nu s-a putut genera raportul de adaos.',
          icon: 'error'
        })
      } finally {
        this.loading = false
        swal.close()
      }
    },
    resetTable () {
      this.tableData = []
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.consumption-total-header {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.form-group {
  display: grid;
}
.left-buttons {
  display: flex;
}
.marfa {
  background-color: orange;
  color: #fff;
}
.semifabricate {
  background-color: #219653;
  color: #fff;
}
.materii-prime {
  background-color: #2f80ed;
  color: #fff;
}
.produs-finit {
  background-color: #674BD2;
  color: #fff;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.sticky-column .cell {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/SalesMarkupReport.vue